@if (provider === Provider.Deere) {
<section class="grants-panel">
  <h4>Per-organisation data access</h4>
  <p class="muted small">
    John Deere requires you to grant data access for each organisation
    individually in Operations Center.
  </p>
  @if (loading) {
  <div class="muted">Loading grants&hellip;</div>
  } @if (errorMessage && !loading) {
  <div class="error">{{ errorMessage }}</div>
  } @if (!loading && !errorMessage && grants.length === 0) {
  <div class="muted">No Deere organisations to display.</div>
  } @if (!loading && !errorMessage && grants.length > 0) {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Organisation</th>
        <th scope="col">Grant status</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      @for (g of grants; track g) {
      <tr [class.row-revoked]="isRevoked(g)">
        <td>{{ g.oem_org_name }}</td>
        <td>
          <span class="status-chip status-{{ g.grant_status }}">
            {{ chipLabel(g) }}
          </span>
        </td>
        <td>
          @if (!isRevoked(g)) {
          <button
            class="btn-oem-primary"
            type="button"
            (click)="grant(g.oem_org_id)"
          >
            {{ isGranted(g) ? "Re-grant" : "Grant data access" }}
          </button>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  }
</section>
}
